import { useEffect, useRef } from 'react';

function useDocumentTitle(title, prevailOnUnmount = false) {
	const defaultTitle = useRef('Nitex - Where Fashion Meets Efficiency');

	useEffect(() => {
		document.title = title;
	}, [title]);

	useEffect(
		() => () => {
			if (!prevailOnUnmount) {
				document.title = defaultTitle.current;
			}
		},
		[prevailOnUnmount]
	);
}

export default useDocumentTitle;
